import { makeStyles } from "@material-ui/core";

export const assetLocationWidgetStyle = makeStyles((theme) => ({
    tooltip: {
        padding: '0.5em 1em',
        background: '#fff',
        borderRadius: '5px',
        boxShadow: '2px 3px 10px #d7d6d6',
    },
    graphTootltip: {
        background: theme.palette.background.paper,
        padding: '0.1px 0.6em',
        boxShadow: theme.shadows[3],
        maxWidth: '9rem'
    },
    lotAddress: {
        fontSize: 10
    },
    lotContainer: {
        paddingLeft: '1em'
    },
    filterIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    singleLotCard: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem 1.5rem',
        gap: '0.5rem',
    },
    singleLotCount: {
        fontSize: '6rem',
        fontWeight: 800,
        color: theme.palette.primary.dark,
        lineHeight: 1,
    },
    singleLotLabel: {
        fontSize: 16,
        color: theme.palette.text.secondary,
    },
}));